export default __webpack_public_path__ + "static/easylife365_mail_logo-d220543456785f28f04777c0560a887b.svg";